export enum ExportDeclarationStatus {
  New = 10,
  // Processing = 20,
  // Transport = 30,
}
